<div class="landing" [ngClass]="{ 'landing-fullscreen': !searchInitialized }">
    <!-- Search Section -->
    <div class="search-container">
        <mat-form-field appearance="outline" class="search-bar">
            <mat-label>Search Products</mat-label>
            <input
                matInput
                placeholder="E.g., Shower, Cooktop"
                (keydown.enter)="performSearch()"
                [formControl]="filters.search"
            />
            @if (loading) {
                <mat-icon matSuffix class="spinner-icon">
                    <mat-spinner [diameter]="24" [strokeWidth]="4"></mat-spinner>
                </mat-icon>
            }
            @if (!loading) {
                <button
                    mat-icon-button
                    matSuffix
                    class="search-button"
                    (click)="performSearch()"
                    title="Search"
                    [disabled]="loading"
                >
                    <mat-icon>search</mat-icon>
                </button>
            }
        </mat-form-field>

        <div class="paginator">
            @if (filteredProducts.length > 50) {
                <mat-paginator
                    [length]="filteredProducts.length"
                    [pageSize]="50"
                    (page)="paginate($event)"
                    [hidePageSize]="true"
                >
                </mat-paginator>
            }
        </div>
    </div>

    @if (!searchInitialized) {
        <div class="welcome-header">
            <h1>Product Selection Centre</h1>
            <p>Start by searching for a keyword...</p>
        </div>
    }

    <!-- No Results Section -->
    @if (!loading && searchInitialized && displayedProducts.length === 0) {
        <div class="no-results">
            <h3>
                <mat-icon class="material-icons cb-error">cancel</mat-icon>&nbsp;No search results
                found.
            </h3>
            <p>Try adjusting your search criteria and try again.</p>
        </div>
    }
</div>

@if (searchInitialized) {
    <div class="container">
        <div class="sidebar" [ngClass]="{ 'sidebar-dialog': isInDialog }">
            @if (showCurrentProduct && existingSlotItem?.id != null) {
                <div class="currently-selected-product">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title class="highlighted">
                                {{ currentProductTitle }}
                            </mat-card-title>
                            <mat-card-title>
                                {{ existingSlotItem.itemName }}
                            </mat-card-title>
                            @if (existingSlotItem?.houseAreaName) {
                                <mat-card-subtitle>
                                    <span>House Area</span>
                                </mat-card-subtitle>
                            }
                            <mat-card-title>
                                {{ existingSlotItem.houseAreaName }}
                            </mat-card-title>
                            @if (existingSlotItem?.slotName) {
                                <mat-card-subtitle>
                                    <span>Schedule Item Name</span>
                                </mat-card-subtitle>
                            }
                            <mat-card-title>
                                {{ existingSlotItem.slotName }}
                            </mat-card-title>
                        </mat-card-header>
                    </mat-card>
                </div>
            }
            <!-- Filters Section -->
            <div class="filters">
                <div class="cb-padding-bottom center-center">
                    <button
                        mat-raised-button
                        color="primary"
                        class="reindex-button"
                        (click)="resetFilters()"
                    >
                        Reset Filters
                    </button>
                </div>
                <!-- Categories -->
                @if (products.length > 0) {
                    <div class="filter-group">
                        <h4 (click)="toggleCollapsedState('categories')" class="filter-heading">
                            CATEGORIES
                            <mat-icon>{{
                                collapsedFilters['categories'] ? 'expand_more' : 'expand_less'
                            }}</mat-icon>
                        </h4>
                        @if (!collapsedFilters['categories']) {
                            <div class="filter-options filter-options-categories">
                                <mat-expansion-panel
                                    [expanded]="true"
                                    style="all: unset; padding: 0"
                                >
                                    @if (slotCategories?.length) {
                                        <div class="menu-container">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    recursiveListTmpl;
                                                    context: { $implicit: slotCategories, level: 0 }
                                                "
                                            >
                                            </ng-container>
                                        </div>
                                    } @else {
                                        @if (loadingMenu) {
                                            <p>Loading categories...</p>
                                        }
                                        @if (!loadingMenu) {
                                            <p>No categories available</p>
                                        }
                                    }
                                </mat-expansion-panel>
                                <ng-template #recursiveListTmpl let-items let-level="level">
                                    <ul
                                        [ngClass]="{ 'menu-list': level === 0, submenu: level > 0 }"
                                    >
                                        @for (item of items; track item) {
                                            <li class="menu-item-container">
                                                @if (item.badgeCount > 0) {
                                                    <div
                                                        class="menu-item"
                                                        [class.selected]="isSelectedMenu(item)"
                                                        (click)="selectItem(item, $event)"
                                                    >
                                                        <span>{{
                                                            item.label +
                                                                ' (' +
                                                                item.badgeCount +
                                                                ')'
                                                        }}</span>
                                                        @if (item.children?.length) {
                                                            <span
                                                                class="icon-toggle"
                                                                (click)="
                                                                    toggleCollapsedState(
                                                                        item.label + item.id,
                                                                        $event
                                                                    )
                                                                "
                                                            >
                                                                <mat-icon>
                                                                    {{
                                                                        collapsedFilters[
                                                                            item.label + item.id
                                                                        ]
                                                                            ? 'expand_more'
                                                                            : 'expand_less'
                                                                    }}
                                                                </mat-icon>
                                                            </span>
                                                        }
                                                    </div>
                                                    @if (
                                                        !collapsedFilters[item.label + item.id] &&
                                                        item.children?.length
                                                    ) {
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                recursiveListTmpl;
                                                                context: {
                                                                    $implicit: item.children,
                                                                    level: level + 1
                                                                }
                                                            "
                                                        >
                                                        </ng-container>
                                                    }
                                                }
                                            </li>
                                        }
                                    </ul>
                                </ng-template>
                            </div>
                        }
                    </div>
                }
                <!-- Tiers -->
                @if (tierRanges?.length > 0) {
                    <div class="filter-group">
                        <h4 (click)="toggleCollapsedState('tier')" class="filter-heading">
                            TIER
                            <mat-icon>{{
                                collapsedFilters['tier'] ? 'expand_more' : 'expand_less'
                            }}</mat-icon>
                        </h4>
                        @if (!collapsedFilters['tier']) {
                            <div class="filter-options">
                                @for (tier of tierRanges; track tier) {
                                    <div>
                                        <mat-checkbox
                                            class="custom-checkbox"
                                            [checked]="selectedTierRanges.has(tier.id)"
                                            (change)="toggleTierRange(tier, $event.checked)"
                                        >
                                            {{ tier.label }}
                                        </mat-checkbox>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                <!-- Business Entities -->
                @if (businessEntities?.length > 0) {
                    <div class="filter-group">
                        <h4 (click)="toggleCollapsedState('businessEntity')" class="filter-heading">
                            BUSINESS ENTITIES
                            <mat-icon>{{
                                collapsedFilters['businessEntity'] ? 'expand_more' : 'expand_less'
                            }}</mat-icon>
                        </h4>
                        @if (!collapsedFilters['businessEntity']) {
                            <div class="filter-options">
                                @for (entity of businessEntities; track entity) {
                                    <div>
                                        <mat-checkbox
                                            class="custom-checkbox"
                                            [checked]="selectedBusinessEntities.has(entity.id)"
                                            (change)="
                                                toggleBusinessEntity(entity.id, $event.checked)
                                            "
                                        >
                                            {{ entity.name }}
                                        </mat-checkbox>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                <!-- Dynamic Filters -->
                @if (dynamicFilterOptions?.length > 0) {
                    <div>
                        @for (filter of dynamicFilterOptions; track filter; let i = $index) {
                            <div class="filter-group">
                                <h4
                                    (click)="toggleCollapsedState(filter.key)"
                                    class="filter-heading"
                                >
                                    {{ filter.key.toUpperCase() }}
                                    <mat-icon>{{
                                        collapsedFilters[filter.key] ? 'expand_more' : 'expand_less'
                                    }}</mat-icon>
                                </h4>
                                @if (!collapsedFilters[filter.key]) {
                                    <div class="filter-options">
                                        @for (option of filter.values; track option) {
                                            <div>
                                                <mat-checkbox
                                                    class="custom-checkbox"
                                                    [checked]="
                                                        isSelected('dynamicCategories', {
                                                            key: filter.key,
                                                            value: option
                                                        })
                                                    "
                                                    (change)="
                                                        updateDynamicFilter(
                                                            filter.key,
                                                            option,
                                                            $event.checked
                                                        )
                                                    "
                                                >
                                                    {{ option }}
                                                </mat-checkbox>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                <!-- Misc filter -->
                <form class="flex-col" #productCentreSearchForm="ngForm">
                    <div class="filter-group">
                        <h4 (click)="toggleCollapsedState('misc')" class="filter-heading">
                            MISC
                            <mat-icon>{{
                                collapsedFilters['misc'] ? 'expand_more' : 'expand_less'
                            }}</mat-icon>
                        </h4>
                        @if (!collapsedFilters['misc']) {
                            <div class="filter-options">
                                <div class="flex-row">
                                    <mat-checkbox
                                        class="custom-checkbox"
                                        name="activeOnly"
                                        [(ngModel)]="filters.activeOnly"
                                        (change)="toggleActiveOnly($event.checked)"
                                    >
                                        Active Products Only
                                    </mat-checkbox>
                                </div>
                                <div class="flex-row">
                                    <cb-select
                                        label="Product Type"
                                        style="height: 45px"
                                        class="cb-margin-right-2x filter-type flex"
                                        name="productType"
                                        [(ngModel)]="filters.productType"
                                        (change)="productSearchTypeChanged()"
                                        [options]="productTypes"
                                    >
                                    </cb-select>
                                </div>
                            </div>
                        }
                    </div>
                </form>
            </div>
        </div>
        <!-- Products Section -->
        <div class="products" [ngClass]="{ 'products-dialog': isInDialog }">
            <!-- Product Grid -->
            @if (!loading && displayedProducts.length > 0) {
                <div class="product-grid">
                    @for (product of displayedProducts; track trackById($index, product)) {
                        <mat-card
                            [ngClass]="{
                                selectable: true,
                                'inactive-product': !product.isActive,
                                selected: existingSlotItem?.id === product.id && showCurrentProduct
                            }"
                            (click)="isInDialog ? selectProduct(product) : viewProduct(product.id)"
                        >
                            <mat-card-header>
                                <mat-card-title>
                                    {{ product.name }}
                                </mat-card-title>
                                <mat-card-subtitle>
                                    <span>{{ product.mainCategory }}</span>
                                </mat-card-subtitle>
                            </mat-card-header>
                            <div class="image-carousel">
                                <img
                                    mat-card-image
                                    class="cb-margin-bottom-2x"
                                    [src]="getProductImage(product)"
                                    alt="{{ product.name }}"
                                    cbHandleInvalidImage
                                />
                            </div>
                            <mat-card-content class="cb-margin-bottom-2x">
                                @if (!hideNationalRate) {
                                    <div>
                                        <strong>National Rate:</strong>
                                        {{
                                            product?.nationalRate < 0
                                                ? '$-'
                                                : (product?.nationalRate | cbCurrency)
                                        }}<br />
                                        @if (product.uomDisplay) {
                                            <span
                                                ><strong>UOM:</strong>
                                                {{ product.uomDisplay }}</span
                                            >
                                        }
                                    </div>
                                }
                                <div class="product-code">
                                    {{ product.code }}&nbsp;
                                    <button
                                        mat-icon-button
                                        matTooltip="Copy product code to clipboard"
                                        (click)="copyProductCodeToClipboard($event, product.code)"
                                    >
                                        <mat-icon svgIcon="clipboard-text-play-outline"></mat-icon>
                                    </button>
                                </div>
                            </mat-card-content>
                            <mat-card-footer>
                                <div>
                                    @if (
                                        product.isCompositeItem &&
                                        product.componentItems?.length <= 0
                                    ) {
                                        <cb-td-icon
                                            svgValue="hexagon-outline"
                                            toolTip="Composite Item with no Items Assigned"
                                        >
                                        </cb-td-icon>
                                    }
                                    @if (
                                        product.isCompositeItem &&
                                        product.componentItems?.length > 0
                                    ) {
                                        <cb-td-icon
                                            svgValue="hexagon-slice-6"
                                            toolTip="Composite Item with Items Assigned"
                                        >
                                        </cb-td-icon>
                                    }
                                </div>
                                <div>
                                    @for (
                                        productTier of product.tiers;
                                        track trackById($index, productTier)
                                    ) {
                                        @if (
                                            productTier.tier !== TIER_ENUM.None &&
                                            tierMatchesBusinessEntity(productTier)
                                        ) {
                                            <cb-display-pill
                                                class="cb-margin-right cb-no-padding"
                                                [backgroundColor]="getPillColour(productTier.tier)"
                                                [textColor]="'black'"
                                                [fontWeight]="'normal'"
                                                [displayPillText]="
                                                    productTier.tier | cbEnumToLabel: TIER_ENUM
                                                "
                                                [additionalHoverInformation]="
                                                    getNamesForBusinessEntities(
                                                        productTier,
                                                        selectedBusinessEntities
                                                    )
                                                "
                                            >
                                            </cb-display-pill>
                                        }
                                    }
                                    @if (product.isStandardProduct) {
                                        <cb-display-pill
                                            class="cb-margin-right cb-no-padding"
                                            [fontWeight]="'normal'"
                                            [displayPillText]="'Standard'"
                                        ></cb-display-pill>
                                    }
                                </div>
                            </mat-card-footer>
                        </mat-card>
                    }
                </div>
            }
        </div>
    </div>
}
